'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ContentMessage = require('./ContentMessage');

var _ContentMessage2 = _interopRequireDefault(_ContentMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorPage = function (_React$Component) {
	_inherits(ErrorPage, _React$Component);

	function ErrorPage(props) {
		_classCallCheck(this, ErrorPage);

		var _this = _possibleConstructorReturn(this, (ErrorPage.__proto__ || Object.getPrototypeOf(ErrorPage)).call(this, props));

		_axwayReactIntl2.default.init(_this);

		// Define the potential error messages
		_this.errorCtx = [_this.intl.formatMsg('Unable to complete requested action.', 'error.summary.generic'),

		// network errors
		_this.intl.formatMsg('Connection Error', 'error.title.NETWORK_ERROR.generic'), _this.intl.formatMsg('Connection errors can occur due to network failures, server availability, or firewall configuration problems.', 'error.summary.NETWORK_ERROR'), _this.intl.formatMsg('Check your connection then try again.', 'error.detail.NETWORK_ERROR.generic'),

		// General causes
		_this.intl.formatMsg('Bad Request', 'error.detail.400'), _this.intl.formatMsg('Unauthorized', 'error.detail.401'), _this.intl.formatMsg('Forbidden', 'error.detail.403'), _this.intl.formatMsg('Not Found', 'error.detail.404'), _this.intl.formatMsg('Method Not Allowed', 'error.detail.405'), _this.intl.formatMsg('Not Acceptable', 'error.detail.406'), _this.intl.formatMsg('Proxy Authentication Required', 'error.detail.407'), _this.intl.formatMsg('Request Time-out', 'error.detail.408'), _this.intl.formatMsg('Conflict', 'error.detail.409'), _this.intl.formatMsg('Gone', 'error.detail.410'), _this.intl.formatMsg('Length Required', 'error.detail.411'), _this.intl.formatMsg('Precondition Failed', 'error.detail.412'), _this.intl.formatMsg('Request Entity Too Large', 'error.detail.413'), _this.intl.formatMsg('Request-URI Too Large', 'error.detail.414'), _this.intl.formatMsg('Unsupported Media Type', 'error.detail.415'), _this.intl.formatMsg('Internal Server Error', 'error.detail.500'), _this.intl.formatMsg('Bad Gateway', 'error.detail.502'), _this.intl.formatMsg('Service Unavailable', 'error.detail.503'), _this.intl.formatMsg('Unexpected failure.', 'error.detail.generic')];
		return _this;
	}

	_createClass(ErrorPage, [{
		key: 'getMessage',
		value: function getMessage(prefix, key) {
			var intl = this.props.intl;

			var msgId = prefix + (key || 'generic');
			var msg = intl.formatMessage({ id: msgId });
			if (!msg || msg === msgId) {
				// Load the generic message
				msgId = prefix + 'generic';
				msg = intl.formatMessage({ id: msgId });
				msg = msg === msgId ? null : msg;
			}
			return msg;
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    modal = _props.modal,
			    errorDetail = _props.errorDetail,
			    onClose = _props.onClose,
			    onAction = _props.onAction,
			    actionLabel = _props.actionLabel;


			console.error(this.title + ':', errorDetail);

			var imgClass = this.props.imgClass;
			if (errorDetail.action === 'NETWORK_ERROR') {
				imgClass = 'gg icon-GG-cloud-alert ';
			}

			return _react2.default.createElement(_ContentMessage2.default, _extends({}, this.props, {
				inlineContent: modal ? !modal : true,
				className: (0, _classnames2.default)(this.props.className, 'errorpage'),
				onClose: onClose,
				imgClass: imgClass,
				title: this.title,
				summary: this.summary,
				detail: this.detail,
				onAction: onAction || onClose,
				actionLabel: onAction && actionLabel || onClose && this.intl.formatMsg('Close')
			}));
		}
	}, {
		key: 'title',
		get: function get() {
			var errorDetail = this.props.errorDetail;


			var title = void 0;
			if (errorDetail.status && errorDetail.action) {
				// For now assume if we get a status it came from the server.
				title = this.getMessage('error.title.' + errorDetail.action + '.', errorDetail.status);
				title = title || this.intl.formatMsg('Server error', 'error.title.servererror');
			} else if (errorDetail.action) {
				title = this.getMessage('error.title.' + errorDetail.action + '.', errorDetail.type || '');
			}

			return title || this.intl.formatMsg('Generic error', 'error.title.genericerror');
		}
	}, {
		key: 'summary',
		get: function get() {
			var errorDetail = this.props.errorDetail;

			return this.getMessage('error.summary.', errorDetail.action);
		}
	}, {
		key: 'detail',
		get: function get() {
			var errorDetail = this.props.errorDetail;

			var detailMsg = void 0;

			if (errorDetail.action) {
				// Allow action specific overrides
				detailMsg = this.getMessage('error.detail.' + errorDetail.action + '.', errorDetail.status);
			}

			return detailMsg || this.getMessage('error.detail.', errorDetail.status);
		}
	}]);

	return ErrorPage;
}(_react2.default.Component);

ErrorPage.propTypes = {
	onClose: _propTypes2.default.func,
	onAction: _propTypes2.default.func,
	actionLabel: _propTypes2.default.string,
	modal: _propTypes2.default.bool,
	imgClass: _propTypes2.default.string,
	className: _propTypes2.default.string,
	errorDetail: _propTypes2.default.shape({
		action: _propTypes2.default.string,
		status: _propTypes2.default.number,
		statusText: _propTypes2.default.string,
		data: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object]),
		error: _propTypes2.default.object
	}).isRequired
};

ErrorPage.defaultProps = {
	className: '',
	imgClass: 'gg icon-GG-cross-circle '
};

var _default = (0, _reactIntl.injectIntl)(ErrorPage);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(ErrorPage, 'ErrorPage', 'src/components/ErrorPage.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/ErrorPage.jsx');
}();

;